// Maintenance mode is driven by the `Site_Under_Maintenance` env key (see vue.config.js).
// Env values are baked in at build time, so changing it requires a rebuild/redeploy.
export const isSiteUnderMaintenance =
  String(process.env.VUE_APP_SITE_UNDER_MAINTENANCE || '').trim().toLowerCase() === 'true'

// Google Apps Script web app URL that stores the signup in the sheet and sends the email.
export const maintenanceFormUrl = (process.env.VUE_APP_MAINTENANCE_FORM_URL || '').trim()
